import styled from 'styled-components';
import { Brands } from '../common/constants';


export default styled.div`
  ${(props) => `
    background: ${props.theme.colours.bg};
    border: 1px solid transparent;
    max-width: calc(${props.theme.misc.appWidth} + ${
    props.theme.whitespace.xl
  } * 2);
    margin: 0 auto;
    box-sizing: border-box;
  `};
`;
export const LayoutHeader = styled.div`
  ${(props) => `
    border-bottom: ${props.theme.borders.box};
    padding: ${props.theme.whitespace.large} ${props.theme.whitespace.xl};
    padding-bottom: ${
      props.theme.borders.box ? props.theme.whitespace.large : 0
    };
  `};
`;
export const LayoutFooter = styled.div``;
export const LayoutBody = styled.div`
  ${(props) => `
    margin: ${props.theme.whitespace.large} ${props.theme.whitespace.xl};
    box-sizing: border-box;
  `}

  @media (min-width: 320px) {
    ${(props) => props.brand === Brands.Wireless && props.theme.type.layoutBody}
  }

  @media (min-width: 768px) {
    ${(props) => props.brand === Brands.Wireless && props.theme.type.layoutBodyMaxWidth}
  }
  
  @media (max-width: 320px) {
    ${(props) => props.brand === Brands.Wireless && props.theme.type.layoutBodyXs}
  }
`;
